var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-[16px] h-[16px] rounded-full border flex items-center justify-center",class:_vm.value ? `!border-[${_vm.color}]` : '!border-[#D3DCE6]'},[(_vm.value)?_c('div',{staticClass:"w-[70%] h-[70%] rounded-full text-danger",class:`!bg-[${_vm.color}]`}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }